import { Box, CircularProgress, Typography } from "@mui/material"

export const Loader = ({ isLoading }) => {
    return isLoading ? <Box
        sx={{
            minHeight: "100px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
        }}
    >
        <CircularProgress size={32} />
    </Box> : null
}


export const Error = ({ isError }) => {
    return isError ? <Box
        sx={{
            minHeight: "100px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            px: 2,
        }}
    >
        <Typography
            sx={{
                fontFamily: "Outfit, sans-serif",
                fontSize: "14px",
                color: "#FF4F8B",
                textAlign: "center",
            }}
        >
            Failed to load data. Please try again.
        </Typography>
    </Box> : null
}